import { DateTime, IGetTime } from '../../../FrontApplet/Management/Time/ITime';
import { EmptyObject } from '../../EmptyObject';

export type ManagementTimeRequests = ManagementTimeGetTimeRequest | ManagementTimeSetManualRequest | ManagementTimeSetNTPRequest;

export const ManagementTimeGetTimeRequest = 'sos.Monitoring.Management.ManagementTimeGetTimeRequest';
export interface ManagementTimeGetTimeRequest {
	type: typeof ManagementTimeGetTimeRequest;
}

export const ManagementTimeGetTimeResult = 'sos.Monitoring.Management.ManagementTimeGetTimeResult';
export interface ManagementTimeGetTimeResult {
	type: typeof ManagementTimeGetTimeResult;
	result: IGetTime;
}

export const ManagementTimeSetManualRequest = 'sos.Monitoring.Management.ManagementTimeSetManualRequest';
export interface ManagementTimeSetManualRequest {
	type: typeof ManagementTimeSetManualRequest;
	dateTime: DateTime;
	timezone: string;
}

export const ManagementTimeSetManualResult = 'sos.Monitoring.Management.ManagementTimeSetManualResult';
export interface ManagementTimeSetManualResult {
	type: typeof ManagementTimeSetManualResult;
	result: EmptyObject;
}

export const ManagementTimeSetNTPRequest = 'sos.Monitoring.Management.ManagementTimeSetNTPRequest';
export interface ManagementTimeSetNTPRequest {
	type: typeof ManagementTimeSetNTPRequest;
	ntpServer: string;
	timezone: string;
}

export const ManagementTimeSetNTPResult = 'sos.Monitoring.Management.ManagementTimeSetNTPResult';
export interface ManagementTimeSetNTPResult {
	type: typeof ManagementTimeSetNTPResult;
	result: EmptyObject;
}
